<template>
	<img src="/frontend/images/logos/toetsmij-primary.svg" alt="ToetsMij logo" class="logo" width="150" />
</template>
